import React, { useEffect, useState } from "react";
import axiosInstance, { handleApiError } from "../../services/axiosService";
import Input from "../FormComponents/Input";
import ButtonActionIcon from "./ButtonActionIcon";
import SingleSelectBox from "../FormComponents/SingleSelectBox";

const FolderTags = ({ tagValue, onChange }) => {
  const [options, setOptions] = useState([]);
  const [newTag, setNewTag] = useState("");
  const [showCreateTag, setShowCreateTag] = useState(false);

  const fetchAllFolderTags = async () => {
    try {
      const { data } = await axiosInstance.get(`/folder-tag`);
      setOptions(data);
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleTags = (selectedOption) => {
    if (selectedOption.id === "" && selectedOption.name === "") {
      onChange([], "folder_info_tag");
      return;
    }
    onChange([selectedOption.id], "folder_info_tag");
  };

  const addNewFolderTag = async () => {
    if (newTag.trim() === "") {
      return;
    }
    try {
      const { data } = await axiosInstance.post(`/folder-tag`, { name: newTag });
      setOptions([...options, data]);
      onChange([data.id], "folder_info_tag");
      setNewTag("");
      setShowCreateTag(false);
    } catch (error) {
      handleApiError(error);
    }
  };

  const getSelectedData = () => {
    if (tagValue && tagValue.length > 0) {
      return options.find((option) => option.id === tagValue[0]);
    }
    return null;
  };

  useEffect(() => {
    fetchAllFolderTags();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="builder_form mb_4">
      <SingleSelectBox
        options={options || []}
        selectedData={getSelectedData()}
        onChange={handleTags}
        label="Assign Folder"
        placeholder="Select a folder"
        isSearch={true}
        valueKey="id"
        labelKey="name"
        containerClassName="mb_0"
      />

      <div className="d_flex gap_2 align_center">
        <Input type="checkbox" checked={showCreateTag} onChange={(e) => setShowCreateTag(e.target.checked)} />
        <label>Want to create new folder?</label>
      </div>

      {showCreateTag && (
        <div className="d_flex gap_2 align_center mb_2">
          <Input
            type="text"
            value={newTag}
            onChange={(e) => setNewTag(e.target.value)}
            placeholder="Enter new folder tag"
            label="Create new folder tag"
          />
          <ButtonActionIcon
            type="add"
            size="sm"
            onClick={addNewFolderTag}
            style={{ marginTop: "auto", marginBottom: "4px" }}
          />
        </div>
      )}
    </div>
  );
};

export default FolderTags;
